import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { nextTick } from 'process';
import { AddressViewModel } from '../../../shared/components';

/**
 * 地址下拉元件轉換
 *
 * @export
 * @class InputAddressSelectorComponent
 */
@Component({
  selector: 'sigv-input-address-selector',
  templateUrl: './input-address-selector.component.html',
  styleUrls: ['./input-address-selector.component.css'],
})
export class InputAddressSelectorComponent implements OnInit {
  /**
   * 地址層級Form Control
   */
  @Input() level1: AbstractControl | any;
  @Input() level2: AbstractControl | any;
  @Input() level3: AbstractControl | any;
  @Input() level4: AbstractControl | any;
  @Input() level5?: AbstractControl | any;
  @Input() native?: AbstractControl | any;
  @Input() postcode?: AbstractControl | any;
  @Input() isRequired: boolean = false;
  @Input() isNativeAddressRequired: boolean = false;
  /** Level5 (詳細地址) 最大長度 - 預設2100字數 */
  @Input() level5MaxLength: number = 2100;
  /** 是否純檢視 */
  @Input() isReadOnly: boolean = false;
  /**變動事件 */
  @Output() onChange = new EventEmitter<void>();

  model: AddressViewModel = {};

  constructor() {
    nextTick(() => {
      this.model = this.convertToAddressModel();
    });
  }
  ngOnInit(): void {
    this.onSubscribeValue();
  }
  convertToAddressModel() {
    let address: AddressViewModel = {
      level1: this.level1?.getRawValue(),
      level2: this.level2?.getRawValue(),
      level3: this.level3?.getRawValue(),
      level4: this.level4?.getRawValue(),
      level5: this.level5?.getRawValue(),
      native: this.native?.getRawValue(),
      postcode: this.postcode?.getRawValue(),
    };
    address.level5 = address.level5?.trim();
    address.native = address.native?.trim();
    return address;
  }
  onAddressValueChange(event: any) {
    const prevAddressModel = this.convertToAddressModel();
    if (prevAddressModel.level1 != event.level1) {
      this.level1.setValue(event.level1);
      this.onChange.emit(event);
    } else if (prevAddressModel.level2 != event.level2) {
      this.level2.setValue(event.level2 ?? null);
      this.onChange.emit(event);
    } else if (prevAddressModel.level3 != event.level3) {
      this.level3.setValue(event.level3 ?? null);
      this.onChange.emit(event);
    } else if (prevAddressModel.level4 != event.level4) {
      this.level4.setValue(event.level4);
      this.onChange.emit(event);
    } else if (prevAddressModel.level5 != event.level5) {
      this.level5?.setValue(event.level5);
      this.onChange.emit(event);
    } else if (prevAddressModel.native != event.native) {
      this.native?.setValue(event.native);
      this.onChange.emit(event);
    } else if (prevAddressModel.postcode != event.postcode) {
      this.postcode?.setValue(event.postcode ?? null);
      this.onChange.emit(event);
    }
  }
  onSubscribeValue(): void {
    this.level1?.valueChanges.subscribe((value: any) => {
      this.model.level1 = value;
    });
    this.level2?.valueChanges.subscribe((value: any) => {
      this.model.level2 = value;
    });
    this.level3?.valueChanges.subscribe((value: any) => {
      this.model.level3 = value;
    });
    this.level4?.valueChanges.subscribe((value: any) => {
      this.model.level4 = value;
    });
    this.native?.valueChanges.subscribe((value: any) => {
      this.model.native = value;
    });
    this.level5?.valueChanges.subscribe((value: any) => {
      this.model.level5 = value;
    });

    this.postcode?.valueChanges.subscribe((value: any) => {
      this.model.postcode = value;
    });
  }
}
